import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { createBrowserHistory as createHistory } from 'history'
import {Router, Switch, Route} from 'react-router-dom';
import store from './store';

import './assets/scss/index.scss';
import Playground from './components/PlaygroundConstructor';
import Auth from './components/AuthPage';
import AuthModal from './components/AuthModal';
import registerServiceWorker from './registerServiceWorker';
import { setupInterceptors } from './api/interceptor';
import { getUrl, getUser } from './api/app';
import { URL_AUTH, USER_LOCALSTORAGE_KEY } from './utils/Constant';
import { getAuth, updateAuth } from './utils/localStoreHelper';

// Функция инициализации режима работы
const initializeAuthMode = async () => {
  const auth = getAuth();

  if (auth) {
    const tempAuth = {};
    if (auth.token !== undefined) {
      // токен существует, даже если он равен пустой строке, пользователь авторизован
      tempAuth.token = auth.token;
      tempAuth.isGuest = false;
    } else {
      // в auth нет токена, выбран гостевой режим
      tempAuth.isGuest = true;
    }  
    updateAuth(tempAuth);
  } else {
        // если ключ auth отсутствует, то нужно вывести модалку с вопросом авторизации
      store.dispatch({
        type: "SET_AUTH_MODAL",
        data: {
          modal: true
        },
      });
  }

  let authUrl;
  try {
    const response = await getUrl(); // Получаем объект с сервера
    authUrl = response.url;
  } catch (error) {
    // Если запрос не удался, используем константу
    authUrl = URL_AUTH;
  }
  updateAuth({url: authUrl})

  try {
    const res = await getUser();
    if (res.success) {
      // Сохраняем только general и erp, исключая success
      const userData = {
        general: res.general || null,
        erp: res.erp || null,
      };
      localStorage.setItem(USER_LOCALSTORAGE_KEY, JSON.stringify(userData));
      // Генерируем кастомное событие для обновления компонентов
      window.dispatchEvent(new Event('userStorageUpdate'));
    } else {
      console.error('Ошибка получения данных пользователя');
    }
  } catch (error) {
    console.error('Ошибка получения данных пользователя', error);
  }
};

// Инициализация
initializeAuthMode();
setupInterceptors(store);
const history = createHistory();
let root = document.getElementById('root');

ReactDOM.render(<Provider store={store}>
  <Router history={history}>
    <Switch>
      <Route path="/auth/access" component={Auth} />
      <Route path="/" component={Playground} />
    </Switch>
    <AuthModal />
  </Router>
  </Provider>, root);

registerServiceWorker();